import { render, staticRenderFns } from "./ExternalCalendarDay.vue?vue&type=template&id=613f9b0a"
import script from "./ExternalCalendarDay.vue?vue&type=script&lang=js"
export * from "./ExternalCalendarDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports